import { useState, createContext, useContext, useEffect } from 'react'
import ModalFullScreen from '../components/Modal/ModalFullScreen'
import { usePriority } from './PriorityContext'

const DialogContext = createContext()

export const DialogProvider = ({ children }) => {
  const [modal, setModal] = useState({
    status: false,
    children: null,
    closeWithEsc: true,
  })

  const { priority, setPriority } = usePriority()

  function dialogClose() {
    setModal({
      status: false,
      children: null,
    })
    setPriority(0)
  }
  function openDialog(children, closeWithEsc = true) {
    setModal({
      status: true,
      children: children,
      closeWithEsc,
    })
    setPriority(1)
  }

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && modal.status && modal.closeWithEsc === true && priority === 1) {
        dialogClose()
      }
    }

    if (modal.status) {
      document.addEventListener('keydown', handleKeyDown)
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [modal.status, priority])


  return (
    <DialogContext.Provider value={{ dialog: modal, openDialog, dialogClose }}>
      {children}
      <ModalFullScreen onClose={dialogClose} activateForm={modal.status}>
        {modal.children}
      </ModalFullScreen>
    </DialogContext.Provider>
  )
}

export const useDialog = () => useContext(DialogContext)
